import React from 'react'
import { CTooltip } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilInfo } from '@coreui/icons'

const InfoTooltip = ({ content }) => (
  <CTooltip content={content}>
    <span className="ms-1">
      <CIcon icon={cilInfo} size="sm" className="text-medium-emphasis" />
    </span>
  </CTooltip>
)

export default InfoTooltip
